// Projeto coberto com parecer enviado: a tela mostra o aviso do parecer no lugar do motivo da reprovação.
const hasSentReviewOpinion = (activity) =>
  !!activity?.coveredByReview && !!activity?.latestReview?.latestSentOpinion

export default hasSentReviewOpinion
